function TextAreaField({ label, ...props }) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <textarea className="field-input field-textarea" {...props} />
    </label>
  );
}

export default TextAreaField;
